import type { ButtonHTMLAttributes } from "react";
import { useDarkMode } from "../../../context/ThemeContext";
import { getThemeClasses } from "../../../utils/ThemeClasses";

interface ReportActionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary";
}

export default function ReportActionButton({
  variant = "primary",
  className = "",
  ...rest
}: ReportActionButtonProps) {
  const { isDarkMode } = useDarkMode();
  const themeClasses = getThemeClasses(isDarkMode);
  const base = "px-4 py-1.5 text-sm font-medium rounded-lg whitespace-nowrap shrink-0 transition-colors disabled:opacity-50 max-lg:flex-1 max-lg:min-h-10 max-lg:px-3 max-lg:whitespace-normal max-lg:text-center";
  const variantClass =
    variant === "primary"
      ? `${themeClasses.buttonBg} text-white ${themeClasses.buttonHover2}`
      : `border-2 ${themeClasses.cardBorder} ${themeClasses.text} hover:border-primary-500 hover:text-primary-500`;

  return <button className={`${base} ${variantClass} ${className}`} {...rest} />;
}
